import React from "react";
import { PageProps } from "../types";

const Header = ({
  title,
  description,
}: Pick<PageProps, "title" | "description">) => (
  <header>
    <h1>{title}</h1>
    <div className="social">
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://twitter.com/intent/tweet?url=https%3A%2F%2Fcanopycanopycanopy.com%2Fcontents%2Fpos&text=Who%20speaks%20to%20you%3F%20Who%20speaks%20for%20you%3F%20%23PartsofSpeech%2C%20a%20series%20of%20six%20projects%20that%20experiment%20with%20the%20forms%20and%20functions%20of%20public%20speech%2C%20is%20organized%20and%20published%20by%20%40Triple_Canopy%20and%20%40PublicFiction."
        className="icon-twitter"
      >
        <span>Twitter</span>
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcanopycanopycanopy.com%2Fcontents%2Fpos"
        className="icon-facebook"
      >
        <span>Facebook</span>
      </a>
    </div>
    <p dangerouslySetInnerHTML={{ __html: description }}></p>
  </header>
);

export default Header;
